export const parseScheduleIndexFromLocation = location => {
  const search = location?.search || (typeof window !== 'undefined' ? window.location.search : '') || ''
  const raw = new URLSearchParams(search).get('scheduleIndex')
  if (raw == null || raw === '') return 0
  const idx = Number(raw)
  return Number.isInteger(idx) && idx >= 0 ? idx : 0
}

/** Prefer wizard draft in Redux over persisted instrument schedules when remounting the editor. */
export const resolveScheduleDraftBootstrap = ({
  instrumentId,
  persistedSchedules,
  schedulingEngineDraft,
  location,
}) => {
  const draftMatchesInstrument =
    schedulingEngineDraft?.instrumentId != null &&
    instrumentId != null &&
    String(schedulingEngineDraft.instrumentId) === String(instrumentId)
  const draftSchedules = draftMatchesInstrument ? schedulingEngineDraft.schedules : null

  const schedules =
    Array.isArray(draftSchedules) && draftSchedules.length ? draftSchedules : persistedSchedules

  let initialScheduleIndex = parseScheduleIndexFromLocation(location)
  if (draftMatchesInstrument && schedulingEngineDraft.activeScheduleId && draftSchedules?.length) {
    const draftIndex = draftSchedules.findIndex(
      schedule => schedule?.id === schedulingEngineDraft.activeScheduleId,
    )
    if (draftIndex >= 0) initialScheduleIndex = draftIndex
  }

  return { schedules, initialScheduleIndex }
}
